import { render, staticRenderFns } from "./AmetrasAdvancedTimelineButtonTemplate.vue?vue&type=template&id=464c3aba&"
import script from "./AmetrasAdvancedTimelineButtonTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasAdvancedTimelineButtonTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
